import { render, staticRenderFns } from "./generic.vue?vue&type=template&id=2100a910&scoped=true"
import script from "./generic.vue?vue&type=script&lang=js"
export * from "./generic.vue?vue&type=script&lang=js"
import style0 from "./generic.vue?vue&type=style&index=0&id=2100a910&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2100a910",
  null
  
)

export default component.exports